import { BrandEnvService, DomainCode } from './brand-env.service';
import { polyfill } from 'es6-promise';
polyfill();
import 'whatwg-fetch';
import fetch from 'isomorphic-fetch';
import { getParameterByName } from '../utilities';

export var EncryptionService = (function() {

    var delinquentStatusFidoCx = false;
    var promise;

    function callRogersApi() {}


    function callFidoApi() {
        var userInfo = decodeURIComponent(
            document.cookie.replace(
                /(?:(?:^|.*;\s*)userInfo\s*=\s*([^;]*).*$)|^.*$/,
                '$1'
            )
        );
        var accountNumber = ( userInfo && userInfo !== '' ) ? JSON.parse(userInfo)['selectedAccountNumber'] : null;
        return fetch('/pages/api/selfserve/v2/accountOverview', {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                accountNumber: BrandEnvService.getAccountNumber() || accountNumber,
                language: BrandEnvService.getCurrentLang(),
                refresh: false
            }),
            method: 'POST'
        })
            .then(function(response) {
                return response.json();
            })
            .then(function(response) {
                var ctnList = response.getAccountInfo.subscriberService[0].service.filter(
                    function(item) {
                        return item.serviceName === 'CTN';
                    }
                );
                if(ctnList.length > 0) return ctnList[0];
                else throw new Error('CTN not found');
            })
            .then(function(subscriptionInfo) {
                var url = '/pages/api/selfserve/v1/wireless/liveChat';
                return fetch(url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        accountNumber: BrandEnvService.getAccountNumber() || accountNumber,
                        ctn: subscriptionInfo.subscriberNo,
                        fName: subscriptionInfo.firstName,
                        lName: subscriptionInfo.lastName,
                        lang: BrandEnvService.getCurrentLang(),
                        lob: 'WL'
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            })
            .then(function(response) {
                return response.json();
            })
            .then(function(response) {
                var source = getParameterByName('source', response.chatUrl);
                delinquentStatusFidoCx = (source == '807' || source == '857') ;
                return {
                    encryptedName: response.encryptedName,
                    encryptedCtn: response.encryptedCtn,
                    encryptedBan: response.encryptedBan
                };
            })
            .catch(function (err) {
                return '';
            });
    }

    return {
        getEncryptedData: function() {
            return BrandEnvService.getDomainCode() === DomainCode.ROGERS
                ? callRogersApi()
                : callFidoApi();
        },
        getDelinquentStatusFidoCx: function () {
            return this.getEncryptedData().then(function() {
                return delinquentStatusFidoCx;
            });
        }
    };
})();
